import {GroupedAttributeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownGroupedGeneric} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useGroupedAttributesSection} from '../../shared/useGroupedAttributesSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: GroupedAttributeFilterSection;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  resetFilter: (slug: string) => void;
  onOpen: (slug: string, label: FilterLabels) => void;
  onClose: (slug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionGroupedAttributes: FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  resetFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {label, slug} = data;
  const {activeSlugFilters, normalizedGroups, handleItemClick} =
    useGroupedAttributesSection({
      data,
      setFilter,
      activeFilters,
    });

  const handleOnReset = () => {
    resetFilter(slug);
  };

  return (
    <FilterDropdownGroupedGeneric
      activeItemIds={activeSlugFilters}
      itemGroups={normalizedGroups}
      label={label}
      onItemClick={handleItemClick}
      onFilterReset={handleOnReset}
      onOpen={() => onOpen(slug, filterLabel)}
      onClose={() => onClose(slug, filterLabel)}
      showSearchField
    />
  );
};
